class customerPage {
  init() {
    $('.forgot-link').click(function(e){
      e.preventDefault();
      $(this).toggleClass('act');
      $('.forgot-form').slideToggle(200);
      $('.forgot-form input[type="email"]').focus();
    });

    if(window.location.hash == '#recover') {
      $('.forgot-form').slideToggle(200);
    }
  }
}

export default customerPage;
